/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosports3ColumnBannersViewProps } from '../../../modules/hosports-3-column-banners/./hosports-3-column-banners';
import Banner from '../../../baseComponents/banner/./banner';
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';
import GridStructure from '../../../baseComponents/grid-structure/./grid-structure';

export default (props: IHosports3ColumnBannersViewProps) => {
  let config = props.config;
  let link1 = '';
  let link1Text = '';
  if(config.link1){
    if(config.link1.linkText){
      link1Text = config.link1.linkText
    }
    if(config.link1.linkUrl){
      link1 = config.link1.linkUrl.destinationUrl;
    }
  }
  let link2 = '';
  let link2Text = '';
  if(config.link2){
    if(config.link2.linkText){
      link2Text = config.link2.linkText
    }
    if(config.link2.linkUrl){
      link2 = config.link2.linkUrl.destinationUrl;
    }
  }
  let link3 = '';
  let link3Text = '';
  if(config.link3){
    if(config.link3.linkText){
      link3Text = config.link3.linkText
    }
    if(config.link3.linkUrl){
      link3 = config.link3.linkUrl.destinationUrl;
    }
  }
  return (
    <ScrollFadeIn>
      <div className="site-gutter">
        <GridStructure
          columns={3}>
          <Banner
            title={config.title1}
            subTitle={config.subTitle1}
            image={config.image1 ? config.image1.src : undefined}
            mobileImage={config.mobileImage1 ? config.mobileImage1.src : undefined}
            verticalPosition={config.verticalPosition}
            horizontalPosition={config.horizontalPosition}
            link={link1}
            buttonText={link1Text}
            tint={config.tint}
            height={config.height}
          />
          <Banner
            title={config.title2}
            subTitle={config.subTitle2}
            image={config.image2 ? config.image2.src : undefined}
            mobileImage={config.mobileImage2 ? config.mobileImage2.src : undefined}
            verticalPosition={config.verticalPosition}
            horizontalPosition={config.horizontalPosition}
            link={link2}
            buttonText={link2Text}
            tint={config.tint}
            height={config.height}
          />
          <Banner
            title={config.title3}
            subTitle={config.subTitle3}
            image={config.image3 ? config.image3.src : undefined}
            mobileImage={config.mobileImage3 ? config.mobileImage3.src : undefined}
            verticalPosition={config.verticalPosition}
            horizontalPosition={config.horizontalPosition}
            link={link3}
            buttonText={link3Text}
            tint={config.tint}
            height={config.height}
          />
        </GridStructure>
      </div>
    </ScrollFadeIn>
  );
};
